import type { IBasicInfoRow } from '@/Services/CampaignManagement/LineItemSummary.service';
import { useFormContext, useWatch } from 'react-hook-form';
import InfoTable, { rowspanTableMaxRows } from './InfoTable';

const CustomDomainListsInfo = () => {
  const { control } = useFormContext();

  const [customAllowDomains, customBlockDomains]: [string[] | undefined, string[] | undefined] = useWatch({
    control,
    name: ['customAllowDomains', 'customBlockDomains'],
  });

  const allowDomains = customAllowDomains ?? [];
  const blockDomains = customBlockDomains ?? [];

  if (!allowDomains.length && !blockDomains.length) {
    return null;
  }

  const rows: IBasicInfoRow[] = [];

  if (allowDomains.length) {
    rows.push(
      ...allowDomains.map((domain, i) => ({
        label: i === 0 ? `Allow List (${allowDomains.length})` : null,
        rowSpan: i === 0 ? allowDomains.length : undefined,
        value: domain,
        thSx: { borderBottom: 'none', borderRight: '1px solid', borderColor: 'divider' } as const,
      })),
    );
  }

  if (blockDomains.length) {
    rows.push(
      ...blockDomains.map((domain, i) => ({
        label: i === 0 ? `Block List (${blockDomains.length})` : null,
        rowSpan: i === 0 ? blockDomains.length : undefined,
        value: domain,
        thSx: { borderBottom: 'none', borderRight: '1px solid', borderColor: 'divider' } as const,
      })),
    );
  }

  return <InfoTable caption='Custom Domain Lists' rows={rows} maxRows={rowspanTableMaxRows} />;
};

export default CustomDomainListsInfo;
